import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, CreditCard, ScrollText, SlidersHorizontal, LogOut, ShieldCheck, ExternalLink } from "lucide-react";
import { useAdmin, RoleChip } from "@/admin/AdminContext";

const NAV = [
  ["/admin", "Overview", LayoutDashboard, null], ["/admin/users", "Users", Users, null], ["/admin/plans", "Subscription Plans", CreditCard, "view_plans"],
  ["/admin/logs", "Activity Logs", ScrollText, null], ["/admin/system", "System Settings", SlidersHorizontal, "system_settings"],
];

export default function AdminLayout({ children }) {
  const { staff, logout, can } = useAdmin();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex bg-white">
      <aside className="w-60 shrink-0 border-r border-zinc-200 bg-zinc-50 flex flex-col sticky top-0 h-screen" data-testid="admin-sidebar">
        <div className="px-5 h-14 flex items-center gap-2 border-b border-zinc-200">
          <div className="h-7 w-7 bg-[#7C3AED] grid place-items-center rounded-sm"><ShieldCheck size={14} className="text-white" /></div>
          <div><p className="font-display font-black text-sm text-zinc-900 leading-none">Fx Cotrader</p><p className="text-[10px] text-zinc-500 uppercase tracking-widest mt-0.5">Admin Portal</p></div>
        </div>
        <nav className="flex-1 p-3 space-y-0.5">
          {NAV.filter(([, , , p]) => !p || can(p)).map(([to, label, Icon]) => (
            <NavLink key={to} to={to} end={to === "/admin"} data-testid={`admin-nav-${label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2 text-sm rounded-sm transition-colors ${isActive ? "bg-white text-[#7C3AED] font-semibold shadow-sm border border-zinc-200" : "text-zinc-600 hover:bg-white hover:text-zinc-900"}`}>
              <Icon size={15} />{label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-zinc-200 space-y-2">
          <p className="text-sm font-medium text-zinc-900 truncate" data-testid="admin-staff-name">{staff?.name}</p>
          <p className="text-[11px] text-zinc-500 truncate">{staff?.email}</p>
          <RoleChip role={staff?.role} testid="admin-staff-role" />
          <div className="flex items-center justify-between pt-2">
            <a href="/" className="flex items-center gap-1 text-[11px] text-zinc-500 hover:text-zinc-900" data-testid="admin-open-app"><ExternalLink size={11} />Trader app</a>
            <button onClick={async () => { await logout(); nav("/admin/login"); }} className="flex items-center gap-1 text-[11px] text-zinc-500 hover:text-[#DC2626]" data-testid="admin-logout-btn"><LogOut size={11} />Sign out</button>
          </div>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 lg:p-8 grid-bg">{children}</main>
    </div>
  );
}
